import type { ReactNode } from "react";

/**
 * The plain chrome every pre-workspace screen sits in.
 *
 * Deliberately not the collector's sidebar shell: these are the screens shown
 * before a workspace has been resolved, where there is nothing to navigate.
 */
export function WorkspaceShell({
  children,
  onSignOut,
  principalName,
}: {
  children: ReactNode;
  onSignOut: () => void;
  principalName?: string;
}) {
  return (
    <div className="workspace">
      <header className="workspace__header">
        <span className="workspace__brand">ONDO</span>
        <span className="workspace__spacer" />
        {principalName && <span className="workspace__who">{principalName}</span>}
        <button type="button" className="workspace__signout" onClick={onSignOut}>
          Sign out
        </button>
      </header>
      <main className="workspace__body">{children}</main>
    </div>
  );
}
